import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6i5zv0objg: FaireBrandEntity = {
  token: "b_6i5zv0objg",
  type: "brand",
  name: "Bird Collective",
  avatarUrl:
    "https://cdn.faire.com/fastly/3c2c116ca866012cc433061b73c36dacb48d1f01ff69a2dde2c2df8261fe11f6.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/75383b175679e5797b2efdb69dcab1486953560cba85f67b2473e4c916116807.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3c2c116ca866012cc433061b73c36dacb48d1f01ff69a2dde2c2df8261fe11f6.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/75383b175679e5797b2efdb69dcab1486953560cba85f67b2473e4c916116807.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 59,
  isTopShop: true,
  isInsider: true,
  description:
    "We have a passion for birds!\n\nBird Collective is a women-owned apparel and accessories company founded in 2019 by Angie Co and Tina Alleva, friends and fellow birdwatchers.\n\nNorth America has lost more than 1 in 4 birds in the last half-century. Through Bird Collective, we're committed to finding and helping fund projects that can help reverse that decline and create a better future for our native birds and wildlife. We partner with groups such as National Audubon Society, HawkWatch International, The American Bird Conservancy, New York City Audubon, Alabama Audubon, The Finch Research Network, the Grassland Bird Trust, and the Yurok Tribe's Condor Restoration Program.\n\nOur apparel and accessories are for bird and nature lovers alike. All of our tees are screen printed locally in Brooklyn in small batches. Every month we release a new embroidered bird patch, and each collectible patch tells the story of the birds we love.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:17.481Z",
    importedBy: "entity-db-cli",
  },
};
